import React from "react";
import RexCounselSite from "./RexCounselSite";

export default function App() {
  return <RexCounselSite />;
}